/**
 * Node modules
 */
import Icon from 'antd/lib/icon';

export default Icon;
